function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 3.785l-2.647.201-.201 2.647-.201-2.647-2.647-.201 2.647-.202.2-2.646.202 2.646L6 3.785z",
  fill: "#00CCBC"
});
function SvgStarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 6 7",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/star-small-9ca6f30e94239c049e111ad338d0b89c.svg";
export { SvgStarSmall as ReactComponent };